import '../../modal/components/modal/modal.component.scss';
import './membership-modal-extensions.scss';

import type { FunctionComponent } from 'preact';
import { useCallback, useEffect, useMemo, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import {
  selectAccountSettings,
  selectAccountSettingsLoaded,
  selectAccountType,
  selectAccountTypeLoaded,
} from '../../auth/store/auth.selectors';
import { checkAccountType, loadAccountSettings } from '../../auth/store/auth.thunk';
import { useTranslation } from '../../i18n';
import type { AppDispatch } from '../../store';
import { useAppSelector } from '../../store/hooks';
import type { ConfirmTermsResult } from '../models/membership.model';

export interface MembershipConfirmTermsModalProps {
  legalTerms: string;
  onClose: (result: ConfirmTermsResult) => void;
}

export const MembershipConfirmTermsModal: FunctionComponent<MembershipConfirmTermsModalProps> = ({
  legalTerms,
  onClose,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const [optInToMarketingEmails, setOptInToMarketingEmails] = useState(true);

  // Redux state
  const accountType = useAppSelector(selectAccountType);
  const accountTypeLoaded = useAppSelector(selectAccountTypeLoaded);
  const accountSettingsResponse = useAppSelector(selectAccountSettings);
  const accountSettingsLoaded = useAppSelector(selectAccountSettingsLoaded);

  // Load account type and settings if not loaded
  useEffect(() => {
    if (!accountTypeLoaded) {
      dispatch(checkAccountType());
    }
    if (!accountSettingsLoaded) {
      dispatch(loadAccountSettings());
    }
  }, [accountTypeLoaded, accountSettingsLoaded, dispatch]);

  const handleConfirm = useCallback(() => {
    onClose({
      termsAccepted: true,
    });
  }, [onClose]);

  const handleCancel = useCallback(() => {
    onClose({
      termsAccepted: false,
    });
  }, [onClose]);

  return (
    <div className="single-membership-confirm-terms-modal">
      <div className="single-modal-header">
        <h3 className="single-modal-title">{t('membership.termsAndConditions')}</h3>
      </div>
      <div className="single-modal-body">
        <div className="message" dangerouslySetInnerHTML={{ __html: legalTerms }} />
      </div>
      <div className="single-modal-footer" style={{ marginTop: '1em' }}>
        <button className="btn button btn-gray" onClick={handleConfirm}>
          {t('membership.confirm')}
        </button>
        <span className="single-membership-cancel" onClick={handleCancel}>
          {t('membership.nevermind')}
        </span>
      </div>
    </div>
  );
};
